// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2lDV5","list":"BalanceDue_list__1b07r","listRow":"BalanceDue_listRow__3jA_F","total":"BalanceDue_total__mT2ro"};